import Tab from "components/DesignSystem/Tab/Tab";
import { useLocation, useRouteMatch } from "react-router-dom";
import { EstimatedTaxDashboardBody } from "./EstimatedTaxDashboardBody";

export const AdvanceTaxAndProfitsDashboardAdmin = () => {
  const { url } = useRouteMatch();
  const { search } = useLocation();

  return (
    <EstimatedTaxDashboardBody
      title="Estimated Tax"
      containerClassName="t-px-8"
      tabNav={
        <Tab.List>
          <Tab.NavTrigger exact value={url} to={`${url}${search}`}>
            Overview
          </Tab.NavTrigger>
          <Tab.NavTrigger
            exact
            value={`${url}/breakdown`}
            to={`${url}/breakdown${search}`}
          >
            Monthly Breakdown
          </Tab.NavTrigger>
          <Tab.NavTrigger
            exact
            value={`${url}/tax-benefits`}
            to={`${url}/tax-benefits${search}`}
          >
            Tax benefits
          </Tab.NavTrigger>
          <Tab.NavTrigger
            exact
            value={`${url}/settings`}
            to={`${url}/settings${search}`}
          >
            Settings
          </Tab.NavTrigger>
        </Tab.List>
      }
    />
  );
};
